import { z } from "zod";
// A served question's answer: 1..5, or null when it was shown but left
// unanswered (an optional program question). The three DEX domain ids
// (serviceListened, serviceReceived, situationImproved) are required and must be
// a real 1..5 value — that presence/non-null check, and per-question option
// rules, are enforced server-side against the form served for the invitation
// (they are contextual and cannot live in this static schema).
const RatingSchema = z.number().int().min(1).max(5).nullable();
// Dynamic map of questionId -> rating. An absent key means the question was not
// on the served form; a null value means it was shown but skipped.
export const SubmitFeedbackSchema = z.object({
    invitationId: z.guid(),
    ratings: z.record(z.string(), RatingSchema),
    additionalComment: z.string().max(2000).optional(),
    // Dynamic map of checkbox fieldId -> answer, mirroring `ratings`. An absent key
    // means the form served no such checkbox; a form with none omits this entirely.
    checkboxes: z.record(z.string(), z.boolean()).optional(),
});
export const FeedbackResultSchema = z.object({
    id: z.guid(),
});
